import AltInstance from '../Globals/Scripts/AltInstance';
import NotificationActions from '../Actions/NotificationActions'

class NotificationStore {
    constructor() {
        this.bindActions(NotificationActions);
        this.notificationDetails = null;
    }

    onNotificationReceived(notificationDetails) {
        this.notificationDetails = notificationDetails;
    }

    onClearNotifications(category) {
        if(category == null || typeof category === 'undefined' || this.notificationDetails && this.notificationDetails.category === category)
            this.notificationDetails = null;
    }
}

export default AltInstance.createStore(NotificationStore, 'NotificationStore');
